import { Link } from '@tanstack/react-router';
import { Settings } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function IntegrationsPrompt(): JSX.Element {
  return (
    <Card className="bg-gradient-to-br from-blue-50 to-purple-50 dark:from-blue-900/20 dark:to-purple-900/20 border-blue-200 dark:border-blue-700">
      <CardContent className="p-8">
        <div className="flex items-center justify-center mb-4">
          <Settings className="w-8 h-8 text-blue-600 dark:text-blue-400" />
        </div>
        <h3 className="text-xl font-semibold text-blue-900 dark:text-blue-100 mb-2">
          <FormattedMessage id="gettingStarted.slackChannels.waiting.integrationsPrompt.title" />
        </h3>
        <p className="text-blue-700 dark:text-blue-300 mb-6">
          <FormattedMessage id="gettingStarted.slackChannels.waiting.integrationsPrompt.description" />
        </p>
        <div className="flex justify-center">
          <Link to="/integrations">
            <Button
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all"
            >
              <Settings className="w-5 h-5 mr-2" />
              <FormattedMessage id="gettingStarted.slackChannels.waiting.integrationsPrompt.button" />
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
